import React, {useContext} from 'react';
import useSWR from "swr";
import {Box, Container} from '@material-ui/core'
import CarouselHOC from "../CarouselHOC";
import {makeStyles, createStyles} from '@material-ui/core/styles';
import {fetchAPIRequestDataSWR} from "@/api/global";
import Testimonial from "@/components/02_molecules/Testimonial/Testimonial";
import CurrentPageContext from "@/components/context/CurrentPageData";

const slickSettContent = {
  dots: false,
  arrows: true,
  infinite: true,
  speed: 500,
  autoplaySpeed: 4000,
  fade: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  autoplay: true
};

const useStyles = makeStyles((theme) => createStyles({
  rootCarousel: {
    '& .slick-slide': {
      padding: 0
    },
    '& .slick-slider': {
      padding: '0 2rem',
      display: 'flex',
      alignItems: 'flex-end',
      [theme.breakpoints.down('sm')]: {
        padding: 0
      }
    },
    '& .slick-list': {
      // minHeight: 240
      height: 'auto',
    }
  },
  slickNext: {
    paddingTop: '1rem',
    right: '-1rem',
    [theme.breakpoints.up('md')]: {
      right: '0'
    },

    '& svg': {
      borderRadius: '4px'
    }
  },
  slickPrev: {
    paddingTop: '1rem',
    left: '-1rem',
    [theme.breakpoints.up('up')]: {
      left: '3rem'
    },
    '& svg': {
      borderRadius: '4px'
    }
  },
  slickArrow: {
    transform: 'none',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Lato',
    '& svg': {
      width: '4.5rem',
      height: '4.5rem',
      color: '#222',
      backgroundColor: '#fff',
      [theme.breakpoints.down('sm')]: {
        width: '3rem',
        height: '3rem'
      }
    }
  }
}));

export default function TestimonialSlider(props) {
  let { children } = props;
  const HOCstyles = useStyles(props);
  const sitewideCtx = useContext(CurrentPageContext); // sitewideCtx?.site can be "baywoods" or "potnets"

  let data,
    error;
  if (!children) {
    ({ data, error } = useSWR(process.env.NEXT_PUBLIC_BACKEND_URL + `/api/block_content/testimonial_block?filter[domSrc]=${sitewideCtx.site}`, fetchAPIRequestDataSWR, {}))
  }

  if (error)
    return <div>Failed to load</div>
  if (!data && !children)
    return <div>Loading...</div>

  return (
    <div className="testimonial-carousel">
      <Container>
        <Box py={4}>
          {
            !data && children && <CarouselHOC classes={HOCstyles} slickSett={slickSettContent}>
              {children}
            </CarouselHOC>
          }
          {
            !children && data && Array.isArray(data?.page_data) &&
            <CarouselHOC classes={HOCstyles} slickSett={slickSettContent}>
              {
                data.page_data.map((t, index) => {
                  return <Testimonial key={`testim-comp-${index}`} node={t} />
                })
              }
            </CarouselHOC>
          }
        </Box>
      </Container>
    </div>
  );
}
